module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[63]428.1754ad1.woff2";